import { useContext } from 'react';
import { Grid } from '@mui/material';

import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../contexts/anonUser';
import { SessionContext, SessionContextType } from '../../../contexts/session';
import PollController from '../PollController';
import OptionPercentage from './OptionPercentage/OptionPercentage';
import OptionVotes from './OptionVotes/OptionVotes';
import { PollRecord } from '../../../models/Poll';

interface OptionResultsProps {
    poll: PollRecord;
    option: 1 | 2;
    mypoll?: boolean;
}

const OptionResults = (props: OptionResultsProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const right = props.option === 2;
    const pollVotes = <OptionVotes {...props} />;
    const pollPct = <OptionPercentage {...props} />;
    const totalVotes =
        props.poll.options[0].votes + props.poll.options[1].votes;

    return (
        <>
            {/* HP4 */}
            {((props.mypoll && totalVotes) ||
                PollController.voted(props.poll.id, session, anonUser)) && (
                <Grid container spacing={0} className='poll-option-results'>
                    <Grid item xs={right ? 9 : 3}>
                        {right ? pollPct : pollVotes}
                    </Grid>
                    <Grid item xs={right ? 3 : 9}>
                        {right ? pollVotes : pollPct}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default OptionResults;
